import TextFieldMui from 'src/components/TextFieldMui'
import { Typography } from '@mui/material'
import theme from 'src/styles/theme'
import styled from 'styled-components'

export const BasicCard = styled.div`
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.gray4};
  border-radius: 8px;
  padding: 8px;
  color: ${theme.colors.gray3};
  margin: 16px 0;
`

export const Title = styled(Typography)`
  color: ${theme.colors.blue};
  font-weight: bold !important;
`
export const Subtitle = styled(Typography)``

export const CustomTextField = styled(TextFieldMui)`
  margin: 16px 0 !important;
`

export const Inline = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
